import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { Sidebar } from '../Sidebar';
import AppLogo from '../../assets/images/app-logo.png';

const titles = {
  '/': 'Brush sets',
  '/academy': 'Academy',
  '/color-palettes': 'Color Palettes',
  '/3d-models': '3D Models',
  '/fonts': 'Fonts',
  '/how-it-works': 'How to install?',
  '/interior-design': 'Interior Design',
  '/stickers': 'Stickers & Textures',
};

const Header = () => {
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  const pathName = window.location.pathname.replace(/\/redirect.*/, '');

  useEffect(() => {
    setSidebarOpen(false);
  }, [location]);

  return (
    <div className='sticky top-0 bg-white z-10'>
      <div className='py-5 px-8 sm:px-4 sm:py-2 flex justify-between items-center'>
        <div className='flex items-center'>
          <button
            type='button'
            className={`focus:outline-none p-2 `}
            onClick={() => setSidebarOpen(true)}
            style={{ outline: 'none' }}
          >
            <span className='sr-only'>Open sidebar</span>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              className='h-[16px] w-[16px]'
              fill='none'
              viewBox='0 0 24 24'
              stroke='currentColor'
              strokeWidth={2}
            >
              <path strokeLinecap='round' strokeLinejoin='round' d='M4 6h16M4 12h16M4 18h16' />
            </svg>
          </button>
          <h1 className='text-lg leading-lg font-bold ml-4 sm:ml-2'>{titles[pathName as keyof typeof titles]}</h1>
        </div>
        <a
          className='flex'
          href='https://toolsforprocreate.onelink.me/zChQ/web'
          target='_blank'
          rel='noopener noreferrer'
        >
          <div className='text-right mr-4'>
            <p className='text-lg leading-lg font-bold'>Tools</p>
            <p className='text-xxs leading-xxs font-medium text-main-grey-800'>Toolbox for Procreate</p>
          </div>
          <img src={AppLogo} alt='app logo' className='shrink-0 w-[39px] h-[39px]' />
        </a>
      </div>
      <Sidebar isOpen={isSidebarOpen} onClose={() => setSidebarOpen(false)} />
    </div>
  );
};

export { Header };
